module.exports = __webpack_public_path__ + "static/media/hall-CSS.239473b6.svg";